module.exports = __webpack_public_path__ + "img/photo14.30e4ec0e.jpg";